import RestService from './RestService'

export default class PageService extends RestService {
    constructor() {
        super('pages')
    }
}